module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('app-header', {
    attrs: {
      "name": _vm.companyName,
      "desc": _vm.companyDesc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _c('main', {
    staticClass: "app-view"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('app-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "app-content col-md-9"
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1)]), _vm._v(" "), _c('app-footer', {
    attrs: {
      "name": _vm.companyName,
      "desc": _vm.companyDesc
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d0577c7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 46
// module chunks = 1